import {
  css,
  useTheme,
} from '@emotion/react';
import classnames from 'classnames';
import React, { useState } from 'react';

import { ContextFiltersSettings } from '@/modules/core/data/types/ContextFiltersSettings';
import { Campus } from '@/modules/core/data/types/Campus';
import { CustomerTheme } from '@/modules/core/data/types/CustomerTheme';
import { EducationalProgram } from '@/modules/core/data/types/EducationalProgram';
import { EducationalProgramStep } from '@/modules/core/data/types/EducationalProgramStep';
import { StudentSolution } from '@/modules/core/data/types/StudentSolution';
import { StudentSolutionsCategory } from '@/modules/core/data/types/StudentSolutionsCategory';
import { OnContextUpdate } from '@/modules/core/data/types/OnContextUpdate';
import { StudentSolutionContext } from '@/modules/core/data/types/StudentSolutionContext';
import ClosedBuilder from './ClosedBuilder';
import OpenBuilder from './OpenBuilder';

type Props = {
  contextFiltersSettings: ContextFiltersSettings;
  allStudentSolutions: StudentSolution[];
  allCampuses: Campus[];
  allEducationalPrograms: EducationalProgram[];
  allEducationalProgramSteps: EducationalProgramStep[];
  allCategories: StudentSolutionsCategory[];
  onContextUpdate: OnContextUpdate;
  context: StudentSolutionContext;
}

const ContextBuilderManager: React.FunctionComponent<Props> = (props): JSX.Element => {
  // eslint-disable-next-line react/prop-types
  const {
    contextFiltersSettings,
    allStudentSolutions,
    allCampuses,
    allEducationalPrograms,
    allEducationalProgramSteps,
    allCategories,
    onContextUpdate,
    context,
  }: Props = props;
  const theme: CustomerTheme = useTheme();
  const { primaryColor } = theme;
  const [isContextBuilderOpen, setIsContextBuilderOpen] = useState(true);

  return (
    <div
      className={classnames('solutions-filters', isContextBuilderOpen ? 'open' : 'closed')}
      css={css`
        position: relative;
        background-color: ${primaryColor};
        color: white;
        text-align: center;
        width: 100%;
        padding: 20px;

        .title {
          font-weight: bold;
          align-content: center;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .content {
          text-align: left;
          margin-top: 10px;
        }

        .toggle-button {
          position: absolute;
          top: 10px;
          right: 10px;
          border-radius: 20px;
          padding: 8px 6px 5px 11px;
        }
      `}
    >
      {
        isContextBuilderOpen ? (
          <OpenBuilder
            contextFiltersSettings={contextFiltersSettings}
            allStudentSolutions={allStudentSolutions}
            allCampuses={allCampuses}
            allEducationalPrograms={allEducationalPrograms}
            allEducationalProgramSteps={allEducationalProgramSteps}
            allCategories={allCategories}
            onContextUpdate={onContextUpdate}
            contextFilters={context}
            setIsContextBuilderOpen={setIsContextBuilderOpen}
          />
        ) : (
          <ClosedBuilder
            contextFiltersSettings={contextFiltersSettings}
            contextFilters={context}
            setIsContextBuilderOpen={setIsContextBuilderOpen}
          />
        )
      }
    </div>
  );
};

export default ContextBuilderManager;
